<template>
  <div class="hero-container text-center full">
    <div class="image-container">
      <div v-if="coverImageContentUnits.length > 0">
        <div
          class="background-image"
          ref="background-images"
          v-for="unit in coverImageContentUnits"
          :key="unit.id"
          :style="{
                    background: 'url(' + context.storageEndpoint + unit.file_name + ') center/cover'
                }"
        ></div>
      </div>
      <div
        v-else
        class="background-image"
        :style="{opacity: 1, background: 'url(' + context.cdnHostStaticAssets + '/images/default-bg-2.jpg) center/cover'}"
      ></div>

      <div class="page-indicator-container" v-if="coverImageContentUnits.length > 1">
        <span
          v-for="(unit, index) in coverImageContentUnits"
          :class="(currentBackgroundImageIndex === index) ? 'page-indicator active' : 'page-indicator'"
          @click="selectBackgroundImage(index)"
        ></span>
      </div>
    </div>
    <div class="grey-overlay"></div>
    <h2 class="slogan-title" v-html="provider.slogan_title"></h2>
    <h2 class="slogan-subtitle" v-html="provider.slogan_subtitle"></h2>
    <time-checking-component
        @service-selected="(service) => this.$emit('service-selected', service)"
        @member-selected="(member) => this.$emit('member-selected', member)"
        :context="context"
        :wrapperClass="'time-checking-component'"
        :provider="provider"
        :compact="compact"
      />
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    provider: {
      type: Object,
      required: true
    },
    compact: { type: Boolean, default: false }
  },

  mounted() {
    this.nextBackground();
    this.resetCrossFade();

    window.addEventListener("focus", this.resetCrossFade);
    window.addEventListener("blur", this.stopCrossFade);
  },

  beforeDestroy() {
    clearInterval(this.crossFadeTimerToken);
    window.removeEventListener("focus", this.resetCrossFade);
    window.removeEventListener("blur", this.stopCrossFade);
  },

  data() {
    return {
      coverImageContentUnits: this.provider.cover_image_content_units,
      crossFadeTimerToken: null,
      currentBackgroundImage: null,
      currentBackgroundImageIndex: -1
    };
  },

  methods: {
    selectBackgroundImage(index) {
      const toImage = this.$refs["background-images"][index];
      const fromImage = this.currentBackgroundImage;

      if (toImage === fromImage) {
        return;
      }

      this.currentBackgroundImage = toImage;
      this.currentBackgroundImageIndex = index;

      $(toImage).animate({ opacity: 1 }, 1000);
      $(fromImage).animate({ opacity: 0 }, 1000);

      this.resetCrossFade();
    },
    stopCrossFade() {
      if (this.crossFadeTimerToken) {
        clearInterval(this.crossFadeTimerToken);
      }
    },
    resetCrossFade() {
      if (this.coverImageContentUnits.length <= 1) {
        return;
      }

      this.stopCrossFade();
      this.crossFadeTimerToken = setInterval(() => {
        this.nextBackground();
      }, 5000);
    },
    nextBackground() {
      const images = this.$refs["background-images"];
      if (!images || images.length === 0) {
        return;
      }

      var oldImage, nextImage;
      if (this.currentBackgroundImage == null) {
        nextImage = images[0];
      } else {
        oldImage = this.currentBackgroundImage;
        nextImage =
          images[
            (images.indexOf(this.currentBackgroundImage) + 1) % images.length
          ];
      }
      this.currentBackgroundImage = nextImage;
      this.currentBackgroundImageIndex = images.indexOf(nextImage);

      $(oldImage).animate({ opacity: 0 }, 1000);
      $(nextImage).animate({ opacity: 1 }, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
.hero-container {
  width: 100%;
  position: relative;
  background-color: #444;
  min-height: 320px;
  padding-bottom: 160px;

  @media(max-width: 480px) {
    min-height: 240px;
    padding-bottom: 80px;
  }
}

.image-container {
  display: inline-block;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

.image-container div.background-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
}

.grey-overlay {
  background-color: rgba(188, 186, 186, 0.35);
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.slogan-title {
  font-size: 3.875rem;
  color: white;
  padding-top: 15rem;
  position: relative;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
  margin-bottom: 0px;
  padding-left: 2rem;
  padding-right: 2rem;

}

.slogan-subtitle {
  font-size: 1.875rem;
  color: white;
  position: relative;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
}

@media (max-width: 480px) {
  .slogan-title {
      padding-top: 7.5rem;
      font-size: 2.4em;
  }

  .slogan-subtitle {
    font-size: 1.4rem;
    color: white;
    position: relative;
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
  }
}

.page-indicator-container {
  width: 100%;
  height: 30px;
  position: absolute;
  z-index: 90;
  bottom: 0;
  text-align: center;
}

.page-indicator {
  width: 12px;
  height: 12px;
  margin: 4px 4px;
  border-radius: 6px;
  background: transparent;
  border: 2px white solid;
  display: inline-block;
}

.page-indicator.active {
  background: white;
}

.time-checking-component {
  max-width: 860px;
}
</style>
